export const TEMPLATE_CATEGORIES = {
  GENERAL: "General",
  REAL_ESTATE: "Real Estate",
  MAP_DATA: "Map & Data",
  CRM: "CRM / Lead Capture",
  CONTENT: "Content",
  ANALYTICS: "Analytics / Experimental",
};

export const CLIENT_VIEW_TEMPLATES = [
  {
    templateKey: "home",
    displayName: "Home",
    description: "Hero, featured content, and primary CTAs.",
    category: TEMPLATE_CATEGORIES.GENERAL,
    supportedDataTypes: ["canonical_real_estate", "custom_static_content"],
  },
  {
    templateKey: "listing-search",
    displayName: "Listing Search",
    description: "Search and filter listings from a query profile.",
    category: TEMPLATE_CATEGORIES.REAL_ESTATE,
    supportedDataTypes: ["canonical_real_estate"],
  },
  {
    templateKey: "listing-detail",
    displayName: "Listing Detail",
    description: "Single listing detail with lead form.",
    category: TEMPLATE_CATEGORIES.REAL_ESTATE,
    supportedDataTypes: ["canonical_real_estate"],
  },
  {
    templateKey: "vehicle-search",
    displayName: "Vehicle Search",
    description: "Search and filter vehicle market inventory.",
    category: TEMPLATE_CATEGORIES.MAP_DATA,
    supportedDataTypes: ["vehicle_market"],
  },
  {
    templateKey: "vehicle-detail",
    displayName: "Vehicle Detail",
    description: "Single vehicle listing detail with lead form.",
    category: TEMPLATE_CATEGORIES.MAP_DATA,
    supportedDataTypes: ["vehicle_market"],
  },
  {
    templateKey: "contact",
    displayName: "Contact",
    description: "Contact form and lead capture.",
    category: TEMPLATE_CATEGORIES.CRM,
    supportedDataTypes: [],
  },
  {
    templateKey: "buyer-concierge-quiz",
    displayName: "Buyer Concierge Quiz",
    description: "Multi-step buyer intent quiz with lead scoring and recommendations.",
    category: TEMPLATE_CATEGORIES.CRM,
    supportedDataTypes: ["vehicle_market"],
  },
  {
    templateKey: "buyer-quiz-results",
    displayName: "Buyer Quiz Results",
    description: "Recommendation results screen after buyer concierge quiz completion.",
    category: TEMPLATE_CATEGORIES.CRM,
    supportedDataTypes: ["vehicle_market"],
  },
  {
    templateKey: "content",
    displayName: "Content",
    description: "Simple content page with title and body blocks.",
    category: TEMPLATE_CATEGORIES.CONTENT,
    supportedDataTypes: ["custom_static_content"],
  },
  {
    templateKey: "dealer-directory",
    displayName: "Dealer Directory",
    description: "Public directory of verified dealers with search and map.",
    category: TEMPLATE_CATEGORIES.MAP_DATA,
    supportedDataTypes: ["vehicle_market"],
  },
  {
    templateKey: "dealer-profile",
    displayName: "Dealer Profile",
    description: "Public dealer profile with inventory and contact CTAs.",
    category: TEMPLATE_CATEGORIES.MAP_DATA,
    supportedDataTypes: ["vehicle_market"],
  },
  {
    templateKey: "dealer-landing",
    displayName: "Dealer Landing",
    description: "Dealer partnership landing page with lead capture.",
    category: TEMPLATE_CATEGORIES.CRM,
    supportedDataTypes: [],
  },
  {
    templateKey: "dealer-free-leads",
    displayName: "Dealer Free Leads",
    description: "Dealer signup page for free lead program.",
    category: TEMPLATE_CATEGORIES.CRM,
    supportedDataTypes: [],
  },
  {
    templateKey: "dealer-demo-request",
    displayName: "Dealer Demo Request",
    description: "Dealer demo request form and scheduling CTA.",
    category: TEMPLATE_CATEGORIES.CRM,
    supportedDataTypes: [],
  },
];

export function createDefaultPageContent(templateKey) {
  switch (templateKey) {
    case "home":
      return {
        homeLayout: "default",
        heroEyebrow: "Welcome",
        heroTitle: "Discover your next experience",
        heroSubtitle: "A manifest-driven public site.",
        heroBody: "Use the sections below to highlight what matters for your audience.",
        primaryCta: { label: "Get started", href: "/search" },
        secondaryCta: { label: "Contact", href: "/contact" },
        featuredTitle: "Featured highlights",
        featuredSubtitle: "Curated items from your configured data sources.",
      };
    case "listing-search":
      return {
        intro: "Search and filter results from your configured listings profile.",
        searchHeading: "Search",
      };
    case "vehicle-search":
      return {
        intro: "Search vehicle market inventory from configured Mobility sources.",
        searchHeading: "Search vehicles",
      };
    case "vehicle-detail":
      return {};
    case "contact":
      return {
        intro: "Send us a message and we will follow up shortly.",
        successMessage: "Thank you. Your message has been received.",
      };
    case "buyer-concierge-quiz":
      return {
        siteName: "AutoMapa",
        quizLayout: "autoclaro-sleek",
      };
    case "buyer-quiz-results":
      return {
        siteName: "AutoMapa",
        resultsLayout: "autoclaro-sleek",
      };
    case "content":
      return { body: "Add your page content here.", sections: [] };
    default:
      return {};
  }
}

export function listTemplatesByCategory() {
  const grouped = {};
  CLIENT_VIEW_TEMPLATES.forEach((template) => {
    if (!grouped[template.category]) {
      grouped[template.category] = [];
    }
    grouped[template.category].push(template);
  });
  return grouped;
}

export function getTemplateMetadata(templateKey) {
  return CLIENT_VIEW_TEMPLATES.find((entry) => entry.templateKey === templateKey) || null;
}
